import { useRef } from "react";
import _ from "lodash";

const useNextFocus = () => {
  const refs = useRef({});
  const setInputRef = name => ref => {
    refs.current[name] = ref;
  };
  const focusInput = name => ev => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      if (_.get(refs, ["current", name, "focus"], null)) {
        refs.current[name].focus();
      }
    }
  };
  const blurInput = name => ev => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      if (_.get(refs, ["current", name, "focus"], null)) {
        refs.current[name].blur();
      }
    }
  };
  const getInputRef = name => refs.current[name];

  return { setInputRef, focusInput, getInputRef, blurInput };
};

export default useNextFocus;
